module.exports = __webpack_public_path__ + "static/media/vf_wbag_core.b05ae0a2.svg";